var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "category-rental-terms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-877.000000, -1633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category-rental-terms",
    transform: "translate(877.000000, 1633.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 243,
    cy: 237,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Signed-document_line_b8",
    transform: "translate(100.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000",
    strokeWidth: 18.4304619
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.528475,268.861292 C343.728114,217.810164 256.37694,111.691615 223.543072,0 L0,158.321137 C27.9866563,315.647413 139.214494,442.409335 288.049689,491.811573 C351.984961,430.646021 413.60721,351.766408 447.528475,268.861292 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.124442,
    y1: 113.948476,
    x2: 60.8850308,
    y2: 181.405606,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.965461,
    y1: 80.7772183,
    x2: 178.932139,
    y2: 97.8004022,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.592724,
    y1: 134.905048,
    x2: 86.6784622,
    y2: 236.832282,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.200081,
    y1: 181.958307,
    x2: 119.4939,
    y2: 287.284651,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.210771,
    y1: 262.735525,
    x2: 158.372959,
    y2: 332.219224,
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "500 278.072972 481.569538 278.072972 481.569538 296.496331 500 296.496331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "444.708614 130.686098 426.278153 130.686098 426.278153 149.109457 444.708614 149.109457"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "472.354307 176.744496 453.923845 176.744496 453.923845 195.167855 472.354307 195.167855"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "490.784769 222.802894 472.354307 222.802894 472.354307 241.226253 490.784769 241.226253"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "407.847691 93.8393799 389.417229 93.8393799 389.417229 112.262739 407.847691 112.262739"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "361.771536 66.2043412 343.341074 66.2043412 343.341074 84.6277003 361.771536 84.6277003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "315.695381 47.780982 297.264919 47.780982 297.264919 66.2043412 315.695381 66.2043412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "260.403996 517.576641 241.973534 517.576641 241.973534 536 260.403996 536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "407.847691 462.306563 389.417229 462.306563 389.417229 480.729922 407.847691 480.729922"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "361.771536 489.941602 343.341074 489.941602 343.341074 508.364961 361.771536 508.364961"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "315.695381 508.364961 297.264919 508.364961 297.264919 526.78832 315.695381 526.78832"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "444.708614 425.459845 426.278153 425.459845 426.278153 443.883204 444.708614 443.883204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "472.354307 379.401447 453.923845 379.401447 453.923845 397.824806 472.354307 397.824806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "490.784769 333.343049 472.354307 333.343049 472.354307 351.766408 490.784769 351.766408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "76.0993771 425.459845 57.6689152 425.459845 57.6689152 443.883204 76.0993771 443.883204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "48.4536842 379.401447 30.0232224 379.401447 30.0232224 397.824806 48.4536842 397.824806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "30.0232224 333.343049 11.5927605 333.343049 11.5927605 351.766408 30.0232224 351.766408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "112.960301 462.306563 94.5298389 462.306563 94.5298389 480.729922 112.960301 480.729922"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "159.036455 489.941602 140.605994 489.941602 140.605994 508.364961 159.036455 508.364961"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "205.11261 508.364961 186.682148 508.364961 186.682148 526.78832 205.11261 526.78832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.079804,317.941121 C365.079804,317.941121 355.385381,345.944627 351.892808,355.193153 C350.611891,358.610686 347.220686,360.978088 343.341074,360.978088 C338.254267,360.978088 334.125843,356.851255 334.125843,351.766408 L334.125843,342.554729 C334.125843,332.375823 327.933208,324.13137 320.302997,324.13137 C312.672786,324.13137 306.48015,332.375823 306.48015,342.554729 C306.48015,347.639576 302.351727,351.766408 297.264919,351.766408 L288.049689,351.766408 C277.866858,351.766408 269.619227,360.010862 269.619227,370.189767 C269.619227,380.368673 277.866858,388.613127 288.049689,388.613127 C293.136496,388.613127 297.264919,392.739959 297.264919,397.824806 L297.264919,416.248165",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.4304619
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.27b071f45d6b53659fbed69d94a9b89b.svg";
export { ForwardRef as ReactComponent };